import { useContext } from 'react';
import GlobalSpinnerContext from '@/contexts/GlobalSpinnerContext';

export default function useGlobalSpinnerContext(): any {
  return useContext(GlobalSpinnerContext);
}
